import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { authApi } from '../services/authApi';
import authReducer from '../features/authSlice';
import previewImagesSlice from '../pages/DocumentTemplateTranslation/Components/UploadPreviewImages/Redux/previewImagesSlice';
import faqsSlice from '../pages/DocumentTemplateTranslation/Components/FAQs/Redux/faqsSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        previewImages: previewImagesSlice,
        faqsReducer: faqsSlice,
        [authApi.reducerPath]: authApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(authApi.middleware),
});

export type appDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

setupListeners(store.dispatch);
